import React, { useState } from 'react';
import moment from 'moment-timezone';
import { Grid, Chip, Box, Tooltip, useTheme } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import References from './References';
import { useStyles } from './style';
import { getSlotsRange, capitalize, mobileScreen } from '../../utils/helpers';
// import DoctariModal from '../Modal';
// import { APPOINTMENT, DOCTOR_BASE, APPOINTMENT_LIGHT } from '../../utils/urls';
// import EditScheduleModal from '../../screens/agenda/EditScheduleModal';

const SCHEDULE_TYPE = {
  internal: 1,
  online: 2,
  faceToFace: 3,
};
const COLOR = {
  internal: '#d7f1da',
  faceToFace: '#d2effd',
  online: '#d4d6fd',
  triple:
    'linear-gradient(to right, #d7f1da 0%,#d7f1da 33%,#000000 33%,#d2effd 33%,#d2effd 66%, #000000 66%, #d4d6fd 66%, #d4d6fd 100%)',
  taken: '#fde9cc',
  selected: 'lightgrey',
  default: '#e6e5e5f0',
};

function DoctariCalendar({
  creatingAvailability,
  creatingAppointment,
  children,
  currentWeek,
  availability,
  setAvailability,
  schedules,
  // deleteSchedule,
  // isAssistant,
  slot,
}) {
  const classes = useStyles();
  const isMobile = mobileScreen();
  const currentFormatted = moment().format('D/M/YYYY HH:mm');
  const { start, end, isEditable } = availability || {};
  const theme = useTheme();
  const [selectedScheduleForAppointment, setSelectedScheduleForAppointment] =
    useState();
  const [
    selectedScheduleForAppointmentDate,
    setSelectedScheduleForAppointmentDate,
  ] = useState();
  const [modalOpen, setModalOpen] = useState({
    appointment: false,
    createSchedule: false,
    deleteSchedule: false,
    scheduleExistAppointment: false,
  });
  const [actionType, setActionType] = useState(null);

  const history = useHistory();

  const selectDate = (date) => {
    if (isEditable) {
      if (start) {
        if (start === date) {
          setAvailability({
            ...availability,
            start: availability.end,
            end: null,
          });
        } else if (moment(start).isSame(moment(date), 'day')) {
          if (moment(start).diff(moment(date)) > 0) {
            setAvailability({
              ...availability,
              start: date,
              end: availability.start,
            });
          } else {
            setAvailability({ ...availability, end: date });
          }
        }
      } else {
        setAvailability({ ...availability, start: date });
      }
    } else {
      if (start === date) {
        setAvailability({ ...availability, start: null });
      } else {
        setAvailability({
          ...availability,
          start: date,
          createModalOpen: true,
        });
      }
    }
  };

  const selectScheduleForAppointment = (schedule, isForEdit) => {
    if (!isForEdit) {
      setModalOpen({ ...modalOpen, appointment: true });
    }
    setSelectedScheduleForAppointment(schedule);
    const scheduleDate = moment(schedule.start)
      .tz(moment.tz.guess())
      .format('LL, h:mm: a');
    setSelectedScheduleForAppointmentDate(scheduleDate);
  };

  const isSelected = (date) => {
    let selected = false;
    if (start === date || end === date) {
      selected = true;
    } else if (start && end && start < date && date < end) {
      selected = true;
    }
    return selected;
  };

  const isDateGreaterOrEqual = (dateString1, dateString2) => {
    const date1 = moment(dateString1, 'D/M/YYYY HH:mm');
    const date2 = moment(dateString2, 'D/M/YYYY HH:mm');

    return date1.isSameOrAfter(date2);
  };

  const Hours = ({ day }) => {
    const hours = getSlotsRange(slot);
    const hoursList = hours.map((hour, index) => {
      let currentScheduleAvailable = false;
      let chipColor = COLOR.default;

      // The server returns the schedules in -03:00 time zone (Montevideo), so we need to convert them to the local timezone.

      //  This is your actual date, with your current date time zone.
      const currentDate = day
        .set('hour', hour.slice(0, 2))
        .set('minute', hour.slice(3, 5))
        .seconds(0)
        // .tz(moment.tz.guess())
        .format('D/M/YYYY HH:mm');

      let currentSchedule = null;
      if (schedules && schedules[currentDate]) {
        // Schedules is an object with the date (with server time zone) as key and an array of schedules as value.
        currentSchedule = schedules[currentDate][0];
      }
      //Calendar painting
      if (currentSchedule) {
        if (currentSchedule.taken == true) {
          // Taken schedule
          chipColor = COLOR.taken;
          currentScheduleAvailable = false;
        } else if (currentSchedule.types.length == 3) {
          // 3 schedules types painted with linear gradient defined as constant
          chipColor = COLOR.triple;
          currentScheduleAvailable = true;
        } else if (currentSchedule.types.length == 2) {
          // 2 schedules types, painted with linear gradient
          chipColor = `linear-gradient(to right, ${
            schedules[currentDate][0].types[0] == SCHEDULE_TYPE.internal
              ? COLOR.internal
              : COLOR.faceToFace
          } 0%, ${
            schedules[currentDate][0].types[0] == SCHEDULE_TYPE.internal
              ? COLOR.internal
              : COLOR.faceToFace
          } 50%,#000000 50%,${
            schedules[currentDate][0].types[0] == SCHEDULE_TYPE.online
              ? COLOR.online
              : COLOR.faceToFace
          } 50%,${
            schedules[currentDate][0].types[0] == SCHEDULE_TYPE.online
              ? COLOR.online
              : COLOR.faceToFace
          } 100%)`;
          currentScheduleAvailable = true;
        } else if (currentSchedule.types.length == 1) {
          // 1 schedule type
          chipColor =
            currentSchedule.types[0] == SCHEDULE_TYPE.internal
              ? COLOR.internal
              : currentSchedule.types[0] == SCHEDULE_TYPE.online
              ? COLOR.online
              : COLOR.faceToFace;
          currentScheduleAvailable = true;
        }
      }

      if (creatingAppointment) {
        // The calendar in which we can create appointment directly. The doctor's profile calendar.
        return (
          <Tooltip title={currentScheduleAvailable ? 'Click para agendar' : ''}>
            <Chip
              label={hour}
              className={classes.chip}
              style={{
                marginBottom: index + 1 === hours.length ? '1rem' : '0rem',
                background: isSelected(currentDate)
                  ? COLOR.selected
                  : chipColor,
                cursor: currentScheduleAvailable ? 'pointer' : 'default',
              }}
              onClick={() =>
                currentScheduleAvailable &&
                selectScheduleForAppointment(currentSchedule)
              }
              clickable={currentScheduleAvailable ? true : false}
              disabled={
                moment().isSameOrAfter(currentDate) || chipColor === COLOR.taken
              }
            />
          </Tooltip>
        );
      } else if (
        moment(hour, 'HH:mm:ss').isBefore(moment('18:00:00', 'HH:mm:ss')) &&
        moment(hour, 'HH:mm:ss').isAfter(moment('07:15:00', 'HH:mm:ss'))
      ) {
        // Classic Doctari calendar. For editing it we have to go to edit mode. Doctor/assistant's home calendar.
        return (
          <Tooltip title={creatingAvailability ? 'Click para agendar' : ''}>
            <Chip
              label={hour}
              className={`${classes.chip} ${
                schedules.hasOwnProperty(currentDate) &&
                isDateGreaterOrEqual(currentDate, currentFormatted) &&
                classes.chipAvailable
              }`}
              style={{
                marginBottom: index + 1 === hours.length ? '1rem' : '0rem',
                background: isSelected(currentDate)
                  ? COLOR.selected
                  : chipColor,
                cursor: creatingAvailability ? 'pointer' : 'default',
              }}
              onClick={() => {
                if (creatingAvailability && chipColor == COLOR.default) {
                  selectDate(currentDate);
                  localStorage.setItem(
                    'selectedDate',
                    JSON.stringify(schedules[currentDate])
                  );
                  history.push('/patient_form');
                } else if (creatingAvailability) {
                  // setModalOpen({
                  //   ...modalOpen,
                  //   scheduleExistAppointment: isAssistant,
                  //   deleteSchedule: !isAssistant,
                  // });
                  selectScheduleForAppointment(schedules[currentDate][0], true); //TODO cambiar esto en el modal de fausto (el select schedule)
                }
                chipColor = COLOR.default;
              }}
              clickable={false}
              disabled={
                !isDateGreaterOrEqual(currentDate, currentFormatted) ||
                !schedules.hasOwnProperty(currentDate)
              }
            />
          </Tooltip>
        );
      }
    });

    return hoursList;
  };

  const Days = () => {
    const calendarDay = [];
    for (let i = 0; i < 7; i++) {
      calendarDay.push(
        <div
          style={{
            border: 'solid 1px white',
            color: `${
              moment().isSame(
                moment()
                  .day(1)
                  .add(currentWeek * 7 + i, 'days')
                  .tz(moment.tz.guess())
              )
                ? '#A12457'
                : 'black'
            }`,
            fontWeight: `${
              moment().isSame(
                moment()
                  .day(1)
                  .add(currentWeek * 7 + i, 'days')
                  .tz(moment.tz.guess())
              ) && 'bold'
            }`,
          }}
        >
          <p className={classes.dayName}>
            {capitalize(
              moment()
                .day(1)
                .add(currentWeek * 7 + i, 'days')
                .tz(moment.tz.guess())
                .format('ddd DD')
            )}
          </p>
        </div>
      );
    }
    return calendarDay;
  };

  const DaysHours = () => {
    const dayHoursList = [];
    for (let i = 0; i < 7; i++) {
      dayHoursList.push(
        <div
          className={classes.hourContainer}
          style={{
            backgroundColor: 'white',
          }}
        >
          <Hours
            day={moment()
              .day(1)
              .add(currentWeek * 7 + i, 'days')
              .tz(moment.tz.guess())}
          />
        </div>
      );
    }
    return dayHoursList;
  };

  const ReferenceSection = () => {
    return (
      <div className={classes.referenceContainer}>
        <References />
        <Box>{children}</Box>
      </div>
    );
  };

  return (
    <Grid container style={{ marginBottom: '5rem' }}>
      <Grid
        item
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className={classes.weekContainer}>
          <div style={{ display: 'flex' }}>
            <Days />
          </div>

          <div className={classes.hourList}>
            <div style={{ display: 'flex' }}>
              <DaysHours />
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export default DoctariCalendar;
